import { useQuery, useMutation } from '@tanstack/react-query';

import Axios from 'axios';
import { queryClient } from 'QueryClientProvider';

const getAccommodation = (accommodationId) => Axios.get(`/accommodation/${accommodationId}`);

const useAccommodation = (accommodationId) => {
    const intID = Number(accommodationId);
    return useQuery({
        queryKey: ['accommodation', intID],
        queryFn: () => getAccommodation(intID),
        staleTime: 60000,
        cacheTime: 60000,
        retry: false,
        enabled: accommodationId ? true : false,
    });
};

const forceReloadAccommodation = (ID) => {
    const intID = Number(ID);
    queryClient.invalidateQueries({ queryKey: ['accommodation', intID] });
};

const onDeleteAccommodation = ({ ID }) => Axios.delete(`/accommodation/${ID}`);

const useDeleteAccommodation = () => {
    return useMutation({
        mutationFn: onDeleteAccommodation,
        onSuccess: (data, variables) => {
            if (variables.ID !== variables.accommodationId) {
                forceReloadAccommodation(variables.accommodationId);
            }
        },
    });
};

const onDeleteAccommodationGroup = ({ GroupGUID }) => Axios.delete(`/accommodations/deletegroup/${GroupGUID}`);

const useDeleteAccommodationGroup = () => {
    return useMutation({
        mutationFn: onDeleteAccommodationGroup,
        onSuccess: (data, variables) => {
            // if (variables.ID !== variables.travelId) {
            //     forceReloadTravel(variables.travelId);
            // }
        },
    });
};

const onUpdateAccommodation = ({ accommodationData }) => Axios.put('/accommodation', accommodationData);

const useUpdateAccommodation = () => {
    return useMutation({
        mutationFn: onUpdateAccommodation,
        onSuccess: (data, variables) => {
            forceReloadAccommodation(variables.accommodationData.ID);
        },
    });
};

const onAddAccommodation = ({ accommodationData }) => Axios.post('/accommodation', accommodationData);

const useAddAccommodation = () => {
    return useMutation({
        mutationFn: onAddAccommodation,
        onSuccess: (data, variables) => {
            forceReloadAccommodation(data.ID);
        },
    });
};

const onUnlinkAccommodation = ({ ID }) => Axios.put(`/accommodation/UnLink/${ID}`);

const useUnlinkAccommodation = () => {
    return useMutation({
        mutationFn: onUnlinkAccommodation,
        onSuccess: (data, variables) => {
            forceReloadAccommodation(variables.accommodationId);
        },
    });
};

const onSetAccommodationProject = ({ accommodationId, projectId }) =>
    Axios.put('/accommodation/SetProject', {
        ObjectID: accommodationId,
        ProjectID: projectId,
    });

const useSetAccommodationProject = () => {
    return useMutation({
        mutationFn: onSetAccommodationProject,
        onSuccess: (data, variables) => {
            forceReloadAccommodation(variables.accommodationId);
        },
    });
};

const onCloneModelsAccommodation = ({ data }) => Axios.post(`/accommodation/CloneForModels`, data);

const useCloneModelsAccommodation = () => {
    return useMutation({
        mutationFn: onCloneModelsAccommodation,
        onSuccess: (data, variables) => {
            forceReloadAccommodation(variables.data.EventID);
        },
    });
};

const onUpdateGroupedIndividualAccommodation = ({ accommodationData }) =>
    Axios.put('/accommodation/GroupedIndividual', accommodationData);

const useUpdateGroupedIndividualAccommodation = () => {
    return useMutation({
        mutationFn: onUpdateGroupedIndividualAccommodation,
        onSuccess: (data, variables) => {
            forceReloadAccommodation(variables.accommodationData.ID);
        },
    });
};

const onUpdateGroupedCommonAccommodation = ({ accommodationData }) =>
    Axios.put('/accommodation/GroupedCommon', accommodationData);

const useUpdateGroupedCommonAccommodation = () => {
    return useMutation({
        mutationFn: onUpdateGroupedCommonAccommodation,
        onSuccess: (data, variables) => {
            forceReloadAccommodation(variables.accommodationData.ID);
        },
    });
};

export {
    getAccommodation,
    useAccommodation,
    useDeleteAccommodation,
    useUpdateAccommodation,
    useAddAccommodation,
    forceReloadAccommodation,
    useSetAccommodationProject,
    useDeleteAccommodationGroup,
    useUnlinkAccommodation,
    useCloneModelsAccommodation,
    useUpdateGroupedIndividualAccommodation,
    useUpdateGroupedCommonAccommodation,
};
